import p5 from "p5";

const sketch = (p: p5) => {
    const fr = 60;
    p.setup = () => {
        p.frameRate(fr);
        p.createCanvas(64, 64);
    };

    p.draw = () => {
        p.background(255, 255, 255, 82);
        p.noStroke();
        const cps = 0.6;
        let phase = (cps * (2 * Math.PI * p.frameCount)) / fr;
        let mainX = 32 + 4 * p.cos(phase);
        let mainSin = p.sin(phase);
        let mainY = 32 + 4 * mainSin;
        let subX = mainX + 24 * p.cos(phase * 2);
        let subY = p.sin(phase * 2.5 + 1);

        p.fill("#844");
        p.ellipse(mainX, mainY, 16, 16);
        p.ellipse(subX, mainY + 12 * subY, 4, 4);
        p.fill(64 - mainSin * 32);
        p.ellipse(mainX, 56, 16 - mainSin * 2, 4 - mainSin);
        p.ellipse(subX, 56 + subY * 4, 4, 1);
    };
};

export default sketch;
